import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus, Sparkles, Camera, Database, X } from "lucide-react";

export default function QuickFab() {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  const go = (url) => {
    setOpen(false);
    nav(url);
  };

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-2" data-testid="quick-fab">
      {open && (
        <div className="flex flex-col gap-2 mb-1 animate-fade-in">
          <button
            onClick={() => go("/gasto-rapido")}
            data-testid="fab-quick-expense"
            className="bg-orange-600 text-white shadow-lg pl-4 pr-5 h-12 inline-flex items-center gap-2 hover:bg-orange-700"
          >
            <Camera className="w-4 h-4" />
            <span className="font-semibold text-sm">Gasto Rápido</span>
          </button>
          <button
            onClick={() => go("/generator")}
            data-testid="fab-generate"
            className="bg-white shadow-lg border border-slate-200 text-slate-900 pl-4 pr-5 h-12 inline-flex items-center gap-2 hover:border-orange-600 hover:text-orange-600"
          >
            <Sparkles className="w-4 h-4" />
            <span className="font-semibold text-sm">Presupuesto IA</span>
          </button>
          <button
            onClick={() => go("/files?upload=1")}
            data-testid="fab-upload-invoice"
            className="bg-white shadow-lg border border-slate-200 text-slate-900 pl-4 pr-5 h-12 inline-flex items-center gap-2 hover:border-orange-600 hover:text-orange-600"
          >
            <Camera className="w-4 h-4" />
            <span className="font-semibold text-sm">Subir factura</span>
          </button>
          <button
            onClick={() => go("/files?upload=1&hint=bc3")}
            data-testid="fab-upload-bc3"
            className="bg-white shadow-lg border border-slate-200 text-slate-900 pl-4 pr-5 h-12 inline-flex items-center gap-2 hover:border-orange-600 hover:text-orange-600"
          >
            <Database className="w-4 h-4" />
            <span className="font-semibold text-sm">Importar BC3</span>
          </button>
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        data-testid="fab-toggle"
        aria-label={open ? "Cerrar" : "Nuevo"}
        className={`h-14 w-14 flex items-center justify-center shadow-xl transition-transform ${open ? "bg-slate-900 text-white rotate-45" : "bg-orange-600 text-white hover:bg-orange-700 hover:scale-105"}`}
      >
        {open ? <X className="w-6 h-6" /> : <Plus className="w-6 h-6" />}
      </button>
    </div>
  );
}
